import { Alert } from "@getbread/dough";
import { Box, type BoxProps } from "@mui/material";
import { useCallback, useState } from "react";
import { stdSpacing } from "../global.style";

export type ErrorComponent = (props: BoxProps) => React.ReactNode;

export type UseErrorMessageReturn = {
	setError: (error: React.ReactNode) => void;
	clearError: () => void;
	ErrorMessage: ErrorComponent;
	hasError: boolean;
};

export function useErrorMessage(): UseErrorMessageReturn {
	const [errorMessage, setErrorMessage] = useState<React.ReactNode>(null);

	const setError = useCallback((error: React.ReactNode) => {
		setErrorMessage(error);
	}, []);

	const clearError = useCallback(() => {
		setErrorMessage(null);
	}, []);

	const ErrorMessage: ErrorComponent = (props) =>
		errorMessage && (
			<Box
				{...props}
				sx={{
					mt: stdSpacing.l,
				}}
			>
				<Alert severity="error">{errorMessage}</Alert>
			</Box>
		);

	const hasError = !!errorMessage;

	return { setError, clearError, ErrorMessage, hasError };
}
